<template>
    <div>
        <ImageInput
            :editable="editable"
            :prefill="img"
            :width="width"
            :height="height"
            :name="customName"
            v-bind="$attrs"
            @change="onChangeImage"
            @edit="onEditImage"
        ></ImageInput>
        <input v-if="!(this.$listeners.change)" ref="imageInput" :name="name" type="file" style="display: none" />
        <Modal v-if="showModal" size="md" @close="onCloseModal" custom-class="modal-cropper-image">
            <div class="px-2 font-semibold text-center">Upload billede</div>
            <div class="text-center text-sm pt-5 px-2">
                <div class="px-4 max-w-[80%] mx-auto d-flex justify-items-center items-center flex-column">
                    <div class="relative">
                        <Cropper
                            :src="img"
                            :stencil-component="stencil"
                            :stencil-props="{
                                aspectRatio: 1,
                                resizable: false,
                                lines: {},
                                handlers: {},
                                movable: false,
                                previewClass: 'cropper__stencil',
                            }"
                            ref="cropper"
                            class="cropper"
                            background-class="cropper__background"
                            foreground-class="cropper__foreground"
                            image-restriction="stencil"
                            default-boundaries="fill"
                            :stencil-size="stencilSize"
                            :transitions="false"
                            :debounce="false"
                            :default-size="defaultSize"
                            :min-width="150"
                            :min-height="150"
                            @change="onChange"
                        ></Cropper>
                    </div>
                    <div class="w-full px-10 flex gap-4 items-center">
                        <span class="range-action" @click="onZoomIn">-</span>
                        <div class="flex-1">
                            <RangeSlider
                                class="slider"
                                :min="0"
                                :max="1"
                                :value="zoom"
                                :step="0.01"
                                @change="onZoom"
                            />
                        </div>
                        <span class="range-action" @click="onZoomOut">+</span>
                    </div>
                </div>

                <div class="flex justify-end gap-2 pt-5 px-2">
                    <button class="btn btn-secondary p-4 px-8" @click="onCloseModal">
                        Cancel
                    </button>
                    <button class="btn btn-load btn-success p-4 px-8 bg-red" @click="onCrop">
                        Submit
                    </button>
                </div>
            </div>
        </Modal>
    </div>
</template>
<style>
.cropper {
    height: 400px;
    width: 400px;
    background: #ddd;
}
.cropper .custom-preview {
    border: 2px solid #fff;
}
.cropper__background {
    background-color: #edf2f4;
}
.cropper__foreground {
    background-color: #edf2f4;
}
.cropper__stencil {
    border: solid 5px #fff;
}
.modal-cropper-image .Modal{
  display: block;
}
.modal-cropper-image .range-slider-knob {
    display: block;
}
.modal-cropper-image .range-slider-fill {
    background: var(--magic-color) !important;
}
.modal-cropper-image .range-slider-knob:after {
    display: none;
}
.modal-cropper-image .range-slider-knob:before {
    background: var(--magic-color);
    bottom: 0;
    margin-top: 0;
    top: -1px;
    height: 15px;
}
.modal-cropper-image .range-action{
    border-radius: 50%;
    background: var(--magic-color);
    width: 20px;
    height: 20px;
    color: white;
    cursor: pointer;
}
</style>
<script type="text/babel">
import 'vue-advanced-cropper/dist/style.css'
import { CircleStencil, Cropper } from 'vue-advanced-cropper'
import ImageInput from 'dashboard-js/components/utilities/ImageInput.vue'
import Modal from 'dashboard-js/components/Modal'
import RangeSlider from 'dashboard-js/components/utilities/RangeSlider.vue'
export default {
    inheritAttrs: false,
    components: {
        RangeSlider,
        Modal,
        ImageInput,
        Cropper,
    },
    props: ['prefill','width','height','name', 'editable'],
    data() {
        return {
            img: this.prefill || null,
            stencil: CircleStencil,
            zoom: 0,
            showModal: false,
            customName: this.$listeners.change ? this.name : null
        }
    },
    methods: {
        base64ToFile(base64String, filename) {
            const arr = base64String.split(',')
            const mimeMatch = arr[0].match(/:(.*?);/)
            const mime = mimeMatch ? mimeMatch[1] : ''
            const bstr = atob(arr[1])
            let n = bstr.length
            const u8arr = new Uint8Array(n)

            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }

            return new File([u8arr], filename, { type: mime })
        },
        defaultSize({ imageSize }) {
            return {
                width: Math.min(imageSize.height, imageSize.width),
                height: Math.min(imageSize.height, imageSize.width),
            }
        },
        stencilSize({ boundaries }) {
            return {
                width: Math.min(boundaries.height, boundaries.width) - 48,
                height: Math.min(boundaries.height, boundaries.width) - 48,
            }
        },
        onChange() {
            const cropper = this.$refs.cropper
            if (cropper) {
                if (cropper.imageSize.height < cropper.imageSize.width) {
                    this.zoom =
                        (cropper.imageSize.height - cropper.coordinates.height) /
                        (cropper.imageSize.height - cropper.sizeRestrictions.minHeight)
                } else {
                    this.zoom =
                        (cropper.imageSize.width - cropper.coordinates.width) /
                        (cropper.imageSize.width - cropper.sizeRestrictions.minWidth)
                }
            }
        },
        onZoom(value) {
            const cropper = this.$refs.cropper
            if (cropper) {
                if (cropper.imageSize.height < cropper.imageSize.width) {
                    const minHeight = cropper.sizeRestrictions.minHeight
                    cropper.zoom(
                        ((1 - this.zoom) * cropper.imageSize.height + minHeight) /
                        ((1 - value) * cropper.imageSize.height + minHeight)
                    )
                } else {
                    const minWidth = cropper.sizeRestrictions.minWidth
                    cropper.zoom(
                        ((1 - this.zoom) * cropper.imageSize.width + minWidth) /
                        ((1 - value) * cropper.imageSize.width + minWidth)
                    )
                }
            }
        },
        changeValueFieldImage(file){
            if (this.$listeners.change) {
                this.$emit('change', {file})
            }else{
                const dataTransfer = new DataTransfer()
                dataTransfer.items.add(file)
                this.$refs.imageInput.files = dataTransfer.files
            }
        },
        onChangeImage(file) {
            this.img = URL.createObjectURL(file.file)
            this.showModal = true
            this.changeValueFieldImage(file.file)
        },
        onCloseModal() {
            this.showModal = false
        },
        onCrop() {
            const {canvas} = this.$refs.cropper.getResult()
            const base64 = canvas.toDataURL("image/jpeg", 0.7)
            this.img = base64
            this.showModal = false
            const file = this.base64ToFile(base64, 'cropped.jpeg')
            this.changeValueFieldImage(file)
        },
        onZoomIn() {
            if(this.zoom > 0){
                this.onZoom(this.zoom - 0.1)
            }
        },
        onZoomOut() {
            if(this.zoom < 1){
                this.onZoom(this.zoom + 0.1)
            }
        },
        onEditImage(){
          this.showModal = true
        }
    },
}
</script>
